export default __webpack_public_path__ + "static/media/re_beg2.45a5eeca.png";